<template>
  <div class="px-3"  v-resize="onResize">
    <v-flex xs12>
      <h1 class="py-md-6">
        {{ $t("viewOrders.title") }}
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="success"
              class="ml-1 green-shadow"
              x-small
              fab
              max-width="26"
              max-height="26"
              v-on="on"
              :title="$t('common.add')"
            >
              <v-icon x-small>$plus</v-icon>
            </v-btn>
          </template>
          <v-list offset-y>
            <v-list-item>
              <v-list-item-title
                class="pointer"
                @click="
                  customer = {};
                  customerId = null;
                  customerEditForm = true;
                "
              >
                {{ $t("viewOrders.order_for_new_customer") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                class="pointer"
                @click="customerFindForm = true"
              >
                {{ $t("viewOrders.order_for_exist_customer") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                class="pointer"
                @click="isVisibleFastOrderWindow = true"
              >
                {{ $t("viewOrders.order_for_fast_diagnostic") }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </h1>
      <v-dialog v-model="customerFindForm" scrollable max-width="500">
        <customerFindForm
          @select="
            (data) => {
              goToSearchWithCustomer(data);
            }
          "
          :visible="customerFindForm"
        ></customerFindForm>
      </v-dialog>
      <v-dialog v-model="customerEditForm" scrollable max-width="890">
        <customerForm
          @removed="customerEditForm=false"
          :is-visible="customerEditForm"
          @store="
            (data) => {
              $store.dispatch('customers/get');
              customerId = data.id;
              customerEditForm = false;
              customerEditForm = true;
            }
          "
          :customer-id="customerId"
        ></customerForm>
      </v-dialog>
      <v-card
        class="mb-2 pa-1"
        :loading="!fetched"
        elevation="0"
        :disabled="!fetched"
      >
        <v-row class="pa-2 ma-0 pb-0">
          <v-flex xs6 md3 pb-2 ma-0 pa-0 pr-2>
            <!---                 class="d-none" -->
            <v-text-field
              :label="$t('common.search')"
              outlined
              :placeholder="$t('viewOrders.search_placeholder')"
              append-icon="fa-times"
              hide-details
              @click:append="
                search = '';
                $router.push({ name: 'orders' });
              "
              v-model="search"
            ></v-text-field>
            <!------>

            <!------>
          </v-flex>
          <v-flex xs6 md3 pb-2 ma-0 pa-0 pr-2>
            <order-statuses-select
                :label="$t('viewSettings.statuses.title_orders')"
                :items="order_statuses"
                :t-prefix="'common.orderSystemStatusNames.'"
                :selected="order_statuses.filter((item)=>item.filter_enabled)"
                @update="(selectedStatuses)=>setOrderStatuses(selectedStatuses)"
            />
          </v-flex>
          <v-flex xs6 md3 pb-2 ma-0 pa-0 pr-2>
            <order-statuses-select
                :circle="true"
                :label="$t('viewOrders.payment_statuses')"
                :items="order_payments_statuses"
                :t-prefix="'common.paymentStatuses.'"
                :selected="order_payments_statuses.filter((item)=>item.filter_enabled)"
                @update="(selectedPaymentStatuses)=>setOrderPaymentStatuses(selectedPaymentStatuses)"
            />
          </v-flex>
          <v-flex xs6 md3 pb-2 ma-0 pa-0 pr-2>
            <v-select
                outlined
                v-if="customerTypes.length > 0"
                :items="customerTypes"
                :label="$t('common.customer_type')"
                item-text="name"
                item-value="id"
                v-model="customerTypeFilter"
                append-outer-icon="fa-times"
                hide-details
                @click:append-outer="
                customerTypeFilter = null;
                ordersGet();
              "
                @change="ordersGet"
            ></v-select>
          </v-flex>
        </v-row>
      </v-card>
      <v-data-table
        :loading="!fetched"
        ref="ordersTable"
        dense
        :height="tableHeight"
        @update:options="setTableOptions"
        :headers="tableHeader"
        :items="filteredOrders"
        :options="tableOptions"
        class="elevation-0 mb-3"

        :server-items-length="ordersTotal"
        @click:row="showOrderWindow(item.id)"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          15, 30
          //-1
        ],
      }"
      >
        <template v-slot:footer.page-text="props">
          {{
            $t("tables.x_of_y", [
              `${props.pageStart}-${props.pageStop}`,
              props.itemsLength,
            ])
          }}
        </template>
        <template v-slot:header.parts_and_repairtimes="{ header }">
          <div class="text-center">
            <v-icon size="12" color="red" class="mr-1">$tools</v-icon
            >{{ $t("common.repairtimes") }}
            <v-icon size="12" class="ml-5 mr-1">$gear_tools</v-icon
            >{{ $t("common.parts") }}
          </div>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <tr class="pa-0 ma-0">
            <td :colspan="headers.length" class="pa-0 ma-0">
<!--              <order-form v-if="order.id" />-->
            </td>
          </tr>
        </template>
        <template v-slot:item="props">
          <tr
            @click="showOrderWindow(props.item.id)"
            :class="{ active: selectedOrder == props.item.id }"
            class="pointer"
          >
            <td class="text-left">{{ props.item.human_number }}</td>
            <td class="text-left py-2 pl-0">
              <span v-if="props.item.customer">
              {{ props.item.customer.last_name }}
              {{ props.item.customer.first_name }}
              {{ props.item.customer.patronymic }}
              {{
                props.item.customer.is_company == 1
                  ? "[" + props.item.customer.legal_name + "]"
                  : ""
              }}
              </span>
              <span v-else>
                {{$t('viewOrders.customer_is_deleted')}}
              </span>
              <div class="d-flex align-center" v-if="props.item.car">
                <div>
                  <img
                    align="center"
                    class="brandLogoMiddle mr-1"
                    v-if="!!brandURL(props.item.car.brand)"
                    :src="brandURL(props.item.car.brand)"
                    :title="props.item.car.brand && props.item.car.brand.toUpperCase()"
                  />
                  <span v-else>
                    {{ props.item.car && props.item.car.brand.toUpperCase() }}
                  </span>
                </div>
                <div class="py-1">
                  <span class="text-caption pr-2"
                    >{{ props.item.car.brand }} {{ props.item.car.family }}
                    {{ props.item.car.model }}</span
                  >
                  <beauty-car-number
                    :number="
                      props.item.car.car_number ? props.item.car.car_number : ''
                    "
                    class="d-inline-block small"
                  />
                </div>
              </div>
            </td>
            <td class="text-left pa-0">
              <span v-if="props.item.customer">
              {{ props.item.customer.phone }}
              </span>
            </td>
            <td class="text-left pa-0">

              <span
                v-if="props.item.customer && props.item.customer.country && props.item.customer.city"
              >
                {{
                  lang === "ru"
                    ? props.item.customer.country.name_ru
                    : props.item.customer.country.name_en
                }},
                {{
                  lang === "ru"
                    ? props.item.customer.city.name_ru
                    : props.item.customer.city.name_en
                }}
              </span>
            </td>
            <td class="text-right">{{ formatCurrency(props.item.total_sum) }}</td>
            <td class="text-xs-left text-no-wrap px-1">
              {{
                props.item.customer && props.item.customer.customer_type
                  ? props.item.customer.customer_type.name
                  : "-"
              }}
            </td>
            <td class="text-xs-left text-no-wrap pa-0 pr-1">
              {{ props.item.created_at | moment("DD.MM.YYYY") }}
              <br/>
              {{ props.item.created_at | moment("HH:mm") }}
            </td>
            <td class="text-xs-left pa-0 pr-1">
              <template
                v-if="
                  props.item.responsible_for &&
                  props.item.responsible_for.length
                "
              >
                <span v-for="resp in props.item.responsible_for">
                  {{ resp.responsible_user && resp.responsible_user.name}},
                </span>
              </template>
              <template v-else>
                {{
                  props.item.created_by_user
                    ? props.item.created_by_user.name
                    : ""
                }}
              </template>
            </td>
            <td class="text-center text-no-wrap pa-0 pr-1">
              <div style="max-width: 80px" class="d-block ma-auto">
                <span v-if="props.item && props.item.itemTypes === 'summary'">
                  <v-icon small color="red" class="mr-1 float-left"
                    >$tools</v-icon
                  >
                  <v-icon small class="mr-1 float-right">$gear_tools</v-icon>
                </span>
                <span v-else-if="props.item && props.item.itemTypes === 'repairtimes'">
                  <v-icon small color="red" class="mr-1 float-left"
                    >$tools</v-icon
                  >
                </span>
                <span v-else-if="props.item && props.item.itemTypes === 'parts'">
                  <v-icon small class="mr-1 float-right">$gear_tools</v-icon>
                </span>
              </div>
            </td>
            <td class="text-center text-no-wrap pa-0">
              <span
                :style="{
                  background: props.item && props.item.status && props.item.status.color,
                  color: props.item && props.item.status && getCorrectTextColor(props.item.status.color),
                }"
                class="pa-1 d-inline-block ma-2 status-square"
              ></span>
              <span
                :style="{
                  background: props.item && props.item.status && props.item.status_payment.color,
                  color: props.item && props.item.status_payment && getCorrectTextColor(props.item.status_payment.color),
                }"
                class="pa-1 d-inline-block ma-2 status-circle"
              ></span>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          {{ $t("common.no_data_available") }}
        </template>
        <template v-slot:no-results>
          {{ $t("common.no_data_available") }}
        </template>
      </v-data-table>
    </v-flex>
    <fast-order-window
        :is-visible="isVisibleFastOrderWindow"
        @search="
            (humanNumber) => {
             this.search = humanNumber;
             this.ordersGet();
            }
          "
        @hide="isVisibleFastOrderWindow=false"
        :customer-id="customerId"
    ></fast-order-window>
    <order-window :is-visible="orderWindow.isVisible" :order-id="orderWindow.orderId" @hide="hideOrderWindow"/>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CustomerForm from "@/components/customer/CustomerForm";
import CustomerFindForm from "@/components/customer/CustomerFindForm";
import CommonMixin from "@/mixins/common";
import BeautyCarNumber from "../../components/common/BeautyCarNumber";
import FastOrderWindow from "../../components/order/FastOrderWindow";
import OrderWindow from "@/components/order/OrderWindow.vue";
import {mapState} from "vuex";
import OrderStatusesSelect from "@/components/order/OrderStatusesSelect.vue";
export default {
  components: {OrderStatusesSelect, OrderWindow, FastOrderWindow, CustomerFindForm, CustomerForm, BeautyCarNumber },
  mixins: [CommonMixin],
  data: () => ({
    findTimeoutId: null,
    selectedOrder: null,
    customerId: null,
    expanded: [],
    customerTypeFilter: null,
    customerFindForm: false,
    customerEditForm: false,
    isVisibleFastOrderWindow: false,
    tableHeight: "100",
    isMounted: false,
    orderWindow:{
      isVisible:false,
      orderId:null
    }
  }),
  mounted() {
    this.tableOptions = {
      page: 1,
          last_page: 1,
          itemsPerPage: 15,
          sortBy: ["human_number"],
          sortDesc: [true],
          groupBy: [],
          groupDesc: [],
          mustSort: false,
          multiSort: false,
    };

    if (this.$route.params.id) {
      this.search = '';
      this.selectedOrder = this.$route.params.id;
    }
    this.$store.dispatch("customer_types/get");
    this.$store
      .dispatch("statuses/statusesGet", { id: this.$route.params.id })
      .then(() => {

          this.ordersGet('mounted');

      });
    this.isMounted = true;
  },
  watch: {
    fetched() {
      this.$nextTick(() => {
        this.setTableHeight();
      });
    },
    search(to, from) {
      if (to.length >= 3 || to.length === 0) {
        clearTimeout(this.findTimeoutId);
        this.findTimeoutId = setTimeout(() => {
          this.ordersGet('search');
        }, 1100);
      }
    },
    $route(to, from) {
      if (this.$route.params.id) {
        this.search = '';
        this.selectedOrder = this.$route.params.id;
      }
    },
  },
  computed: {
    ...mapState("auth", ["authenticated", "authenticatedUser", "isFetching"]),
    ...mapFields("site", ["lang"]),
    ...mapFields("statuses", ["order_statuses", "order_payments_statuses"]),
    ...mapFields("customer_types", ["customerTypes"]),
    ...mapFields("orders", [
      "orders",
      "order",
      "ordersTotal",
      "tableOptions",
      "search",
      "fetched",
    ]),

    filteredOrders() {
      return this.orders.filter((item) => {
        item.itemTypes = this.itemTypes(item.items);
        return true;
      });
    },
    tableHeader() {
      return [
        {
          text: this.$t("viewOrders.tableHeader.human_number"),
          value: "human_number",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.customer"),
          value: "customer.last_name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.phone"),
          value: "customer.phone",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.city"),
          value: "customer.city.name_ru",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewOrders.tableHeader.total_sum"),
          value: "total_sum",
          sortable: true,
          align: "right",
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.customer_type"),
          value: "customer.customer_type",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewOrders.tableHeader.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewOrdersForm.responsible_for"),
          value: "responsible_for",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          value: "parts_and_repairtimes",
          text: this.$t("common.parts_and_repairtimes"),
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewOrders.tableHeader.statuses"),
          value: "status",
          sortable: false,
          class: "text-no-wrap",
        },
      ];
    },
  },
  methods: {
    setOrderPaymentStatuses(selectedPaymentStatuses){
      this.order_payments_statuses.forEach(orderStatus=>{
        orderStatus.filter_enabled = false;
        selectedPaymentStatuses.forEach((selectedStatus)=>{
          if(selectedStatus.id === orderStatus.id && selectedStatus.type === orderStatus.type) {
            orderStatus.filter_enabled = true
          }
        })
      })
      clearTimeout(this.findTimeoutId);
      this.findTimeoutId = setTimeout(() => {
        this.ordersGet();
      }, 1100);
    },
    setOrderStatuses(selectedStatuses){
      this.order_statuses.forEach(orderStatus=>{
        orderStatus.filter_enabled = false;
        selectedStatuses.forEach((selectedStatus)=>{
          if(selectedStatus.id === orderStatus.id && selectedStatus.type === orderStatus.type) {
            orderStatus.filter_enabled = true
          }
        })
      })
      clearTimeout(this.findTimeoutId);
      this.findTimeoutId = setTimeout(() => {
        this.ordersGet();
      }, 1100);
    },
    hideOrderWindow(){
      this.orderWindow.orderId=null;
      this.orderWindow.isVisible=false;
      if (this.$route.params.id) {
        this.$router.push({name: "orders"});
      }
    },
    showOrderWindow(id){
      this.orderWindow.isVisible = true;
      this.orderWindow.orderId = id;
    },
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["ordersTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
    setTableOptions(options) {
      this.tableOptions = options;
      if(!this.isMounted) return;
      this.ordersGet('setTableOptions');
    },
    ordersGet(name=null) {
      //console.log('ordersGet',name)
      let systemOrderStatuses = this.order_statuses.reduce((res, current) => {
        if (current.system && current.filter_enabled) {
          res.push(current.id);
        }
        return res;
      }, []);
      let shopOrderStatuses = this.order_statuses.reduce((res, current) => {
        if (!current.system && current.filter_enabled) {
          res.push(current.id);
        }
        return res;
      }, []);
      let systemOrderPaymentStatuses = this.order_payments_statuses.reduce(
        (res, current) => {
          if (current.system && current.filter_enabled) {
            res.push(current.id);
          }
          return res;
        },
        []
      );

      this.$store
        .dispatch("orders/ordersGet", {
          systemOrderPaymentStatuses,
          systemOrderStatuses,
          shopOrderStatuses,
          customerTypeId: this.customerTypeFilter,
        })
        .then(() => {
          if (this.$route.params.id) {
            this.showOrderWindow(this.$route.params.id)
          }
        });
    },
    itemTypes(items) {
      if(!items) return null;
      let partsNum = items.filter((it) => it.item_type === "part").length; //число деталей в заказе
      let repairtimesNum = items.filter(
        (it) => it.item_type === "repairtime"
      ).length; //число работ в заказе

      if (partsNum > 0 && repairtimesNum > 0) return "summary";
      if (partsNum > 0 && repairtimesNum < 1) return "parts";
      if (partsNum < 1 && repairtimesNum > 0) return "repairtimes";
      return null;
    }
  },
};
</script>
<style lang="css" scoped>
.orderContainer {
  position: fixed;
  right: 0;
  padding-left: 30px !important;
  margin-left: 30px;
  width: 50%;
}
.brandLogoMiddle {
  width: 16px;
}
</style>
